/**
 * Shown instead of the whole signup flow when the backend says self-serve signup is not open (GET
 * /api/self-serve/config answers {cardOnFile:false} on a backend with avrio-backend#310, where the old down-payment
 * Checkout no longer exists and POST /signup would answer 503).
 *
 * Deliberately offers no form and no step of the flow, so nothing here can post to /signup. A visitor gets a way to
 * reach a person instead.
 */

import { Button, Result } from 'antd';
import StandaloneShell from '../../components/standalone-shell';
import { contactHref } from '../../utils/contact';
import { FLEX_COPY } from '../../utils/flexCopy';

const NotOpenYet = () => (
  <StandaloneShell>
    <Result
      status="info"
      title={FLEX_COPY.notOpenTitle}
      subTitle={FLEX_COPY.notOpenBody}
      extra={
        <Button
          type="primary"
          href={contactHref(
            'Avrio self-serve signup',
            'I would like to know when self-serve signup opens, or talk to someone about Avrio now.',
          )}
        >
          {FLEX_COPY.notOpenCta}
        </Button>
      }
    />
  </StandaloneShell>
);

export default NotOpenYet;
